var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DatePicker',{style:({ width: _vm.width + 'px' }),attrs:{"transfer":true,"value":[_vm.value.start, _vm.value.end],"editable":false,"type":"datetimerange","placeholder":"请选择"},on:{"on-change":_vm.onChangeDate}})}
var staticRenderFns = []

export { render, staticRenderFns }